import React, { ReactElement } from 'react';
import { ISelectFooterProps } from './Select';
import { StyledSelectFooter } from './Select.styles';

export function SelectFooter(props: ISelectFooterProps): ReactElement {
    const { children, className } = props;

    return <StyledSelectFooter className={className}>{children}</StyledSelectFooter>;
}
